<template>
    <transition name="slide-fade">
        <div class="notification box"
             v-if="open"
             :id="id && `notification-${id}`"
        >
            <div class="icon-container" :class="type">
                <IconBase display="inline-flex"
                          :key="icon.name"
                          :icon-name="icon.name"
                          :icon-color="icon.color"
                          :width="icon.width"
                          :height="icon.height"></IconBase>
            </div>
            <div class="bodyStrong truncate text">
                {{ body }}
            </div>
            <div class="close-button-wrapper">
                <span class="close-button" @click="close()">
                    <IconBase icon-name="closeV2Icon"
                              :icon-color="closeIcon.color"
                              :icon-hover-color="closeIcon.colorHover"
                              :width="closeIcon.size"
                              :height="closeIcon.size"></IconBase>
                </span>
            </div>
        </div>
    </transition>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';

export const iconMap = {
    general: {
        name: 'bullhornIcon',
        color: consts.COLORS_V2.PRIMARY_500,
        width: 21,
        height: 21
    },
    error: {
        name: 'warningNoteIcon',
        color: consts.COLORS_V2.NEGATIVE_500,
        width: 5,
        height: 16
    },
    success: {
        name: 'checkV2Icon',
        color: consts.COLORS_V2.POSITIVE_500,
        width: 16,
        height: 12
    },
    warning: {
        name: 'warningNoteIcon',
        color: consts.COLORS_V2.NEUTRAL_500,
        width: 8,
        height: 21
    },
    delete: {
        name: 'deleteV2Icon',
        color: consts.COLORS_V2.NEGATIVE_500,
        width: 21,
        height: 21
    }
};


export default {
    name: 'Notification',
    components: { IconBase },
    props: {
        id: Number,
        type: {
            type: String,
            default: 'success',
            validator: (value) => Object.keys(iconMap)
                .includes(value)
        },
        body: String,
        open: Boolean
    },
    data() {
        return {
            closeIcon: {
                color: consts.COLORS.LIGHT_500,
                colorHover: consts.COLORS.LIGHT_600,
                size: 10
            }
        };
    },
    computed: {
        icon() {
            return iconMap[this.type];
        }
    },
    methods: {
        close() {
            this.$emit('cancel');
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide.V2.scss";

.notification {
    position: absolute;
    top: $spacing-m;
    right: $spacing-m;
    @include notificationLayer;
}

$boxWidth: 340px;
.box {
    width: $boxWidth;
    height: $spacing-xxl-8;
    line-height: $spacing-xxl-8;
    border-radius: 8px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px $light-300;
    background-color: $white;
    align-items: center;
    display: grid;
    grid-template-columns: $spacing-xxl-2 auto $spacing-xxl-6;
    column-gap: 12px;
    padding-left: 12px;
}

.icon-container {
    width: 32px;
    height: 32px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    box-sizing: border-box;

    &.general {
        border: solid 2px $primary-200;
    }

    &.error, &.delete {
        border: solid 2px $negative-200;
    }

    &.success {
        border: solid 2px $positive-200;
    }

    &.warning {
        border: solid 2px $neutral-200;
    }
}

.text {
    color: $light-900;
}

.close-button-wrapper {
    border-left: 1px solid $light-300;
    text-align: center;
}

.close-button {
    cursor: pointer;
}

.slide-fade-enter-active {
    transition: all .2s ease;
}
.slide-fade-leave-active {
    transition: all .6s ease;
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX($spacing-m + $boxWidth);
    opacity: 0;
}

</style>
